// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"LandingPage_mainContainer__1vwRQ","wrapper":"LandingPage_wrapper__2gvAA"};